import TrialFormBase from '../common/TrialFormBase';

/**
 * Contact form with trial signup (templates/Element/website/contact_form.php).
 * Shares the whole submission flow with the signup form via TrialFormBase.
 */
export default class ContactForm extends TrialFormBase {
    constructor(formId = 'contact-form') {
        super({ formId, analyticsEvent: 'submit_form_contact' });
    }
}